import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { Button, Card, CardBody, CardHeader } from "reactstrap";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import { AffinityGroupLayoutJSON } from "../Json/AffinityGroupLayoutJson";
import { AffinityGroupFieldsJSON } from "../Json/AffinityGroupFieldsJson";
import CommonButton from "../../../../Components/Common/CommonButton/CommonButton";
import { useNavigate, useParams } from "react-router-dom";
import {
  createAffinityList,
  updateAffinityList,
} from "../AffinityGroupService";
import {
  resetFormState,
  setSelectValidError,
  verifyModal,
} from "../../../../slices/common/reducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { getCategoryDropdown, getData } from "../../../../Utils/CommonService";
import UpdateConfirmationModal from "../Modal/UpdateConfirmationModal";
import SaveConfirmationModal from "../../../Product/Product/Modal/SaveConfirmationModal";
import { checkButtonAccess } from "../../../../Utils/CommonUtils";

const AddAffinityGroup = () => {
  const dispatch = useDispatch();
  const formState = useSelector((state) => state.common.formRendererState);
  const verifyShow = useSelector((state) => state.common.verifyShow);
  const affinityGroupData = useSelector(
    (state) => state.affinityGroup.affinityGroupData
  );
  const agFieldJson = useSelector((state) => state.affinityGroup.agFieldJson);
  const [index, setIndex] = useState(0);
  const navigator = useNavigate();
  const params = useParams();
  const editMode = !!params.id;
  const breadcrumbItems = editMode
    ? [
        { title: "AG", link: "" },
        { title: "Affinity Group", link: "/ag/ag" },
        {
          title: `${formState.code}`,
          link: `/ag/ag/update/${params.id}`,
        },
      ]
    : [
        { title: "AG", link: "" },
        { title: "Affinity Group", link: "/ag/ag" },
        { title: "New Affinity Group", link: "/ag/ag/create" },
      ];

  // const addNewClickHandler = (e) => {
  //   e.preventDefault();
  //   if (formState.status) {
  //     dispatch(setSelectValidError(false));
  //     createAffinityList("AGRP", formState, navigator);
  //   } else {
  //     dispatch(setSelectValidError(true));
  //   }
  // };

  // const updateClickHandler = (e) => {
  //   console.log("hii");
  //   e.preventDefault();
  //   if (formState.status) {
  //     dispatch(setSelectValidError(false));
  //     updateAffinityList(formState, params.id, navigator);
  //   } else {
  //     dispatch(setSelectValidError(true));
  //   }
  // };

  const addNewClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const handleCancel = () => {
    dispatch(resetFormState());
    dispatch(setSelectValidError(false));
    dispatch(verifyModal(false));
    navigator("/ag/ag");
  };

  const confirmSave = (e) => {
    e.preventDefault();
    if (formState.status) {
      dispatch(setSelectValidError(false));
      createAffinityList("AGRP", formState, navigator);
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  const confirmUpdate = (e) => {
    e.preventDefault();
    if (formState.status) {
      dispatch(setSelectValidError(false));
      updateAffinityList(formState, params.id, navigator);
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  useEffect(() => {
    if (params.id) {
      getData(params.id, "AGRP");
    }
  }, []);

  useEffect(() => {
    getCategoryDropdown("AGRP", "ag_category", AffinityGroupFieldsJSON);
  }, []);

  return (
    <>
      <div className="page-content">
        <BreadCrumb items={breadcrumbItems} />
        <Card className="details-wrapper">
          <Form
            onSubmit={editMode ? updateClickHandler : addNewClickHandler}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                // editMode ? updateClickHandler(e) : addNewClickHandler(e);
                editMode ? confirmUpdate(e) : confirmSave(e);
              }
            }}
          >
            {/* <CardHeader> */}
            {/* <SelectedTab
              tabs={tabs}
              activeTab={activeTab}
              changeActiveTab={changeActiveTab}
            /> */}
            <div>
              <div className="mb-3 tab">
                <div className="tab-item">
                  {AffinityGroupLayoutJSON.map((element, ind) => (
                    <div key={element.elementid}>
                      <div
                        className={`nav-link ${index === ind ? "active" : ""}`}
                        onClick={() => setIndex(ind)}
                      >
                        {renderElement(
                          element,
                          agFieldJson,
                          formState,
                          {},
                          () => {
                            setIndex(ind);
                          }
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="selected-tab-bottom-content">
                  {AffinityGroupLayoutJSON[index]?.child?.map((it) =>
                    renderElement(it, agFieldJson, formState, {})
                  )}
                </div>
                <div className="form-footer">
                  <CommonButton
                    handleCancel={handleCancel}
                    // edit={editMode}
                    update={editMode}
                    checkAccess={checkButtonAccess("EDIT", "AG_AG")}
                  />
                </div>
                {verifyShow &&
                  (editMode ? (
                    <UpdateConfirmationModal confirmUpdate={confirmUpdate} />
                  ) : (
                    <SaveConfirmationModal confirmUpdate={confirmSave} />
                  ))}
              </div>
            </div>
          </Form>
        </Card>
      </div>
    </>
  );
};

export default AddAffinityGroup;
